import { jsx } from 'react/jsx-runtime';
import { Flex, themedColor, font, Box } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { rgba } from 'polished';
import { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: translateY(-5px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      min-width: 200px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  right: 0;\n  top: 15px;\n  margin-top: 10px;\n  border: solid 1px ",
        ";\n  background-color: ",
        ";\n  border-radius: 5px;\n  box-shadow: 0 22px 30px -8px ",
        ";\n  min-width: 185px;\n  z-index: 1;\n  text-align: left;\n  ",
        "\n  animation: ",
        " 0.2s ease-in;\n  -webkit-tap-highlight-color: transparent;\n\n  ",
        ";\n\n  a {\n    text-decoration: none;\n    color: ",
        ";\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  padding: 10px 10px 10px 20px;\n  ",
        "\n  text-transform: capitalize;\n\n  &:hover {\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var inflate = keyframes(_templateObject());
var StyledDropDown = styled(Flex)(_templateObject2(), function(param) {
    var theme = param.theme;
    return rgba(theme.colors.glass, 0.43);
}, themedColor("white"), function(param) {
    var theme = param.theme;
    return rgba(theme.colors.black, 0.07);
}, font("main", {
    fontSize: "1.2rem",
    fontWeight: 700
}), inflate, MEDIA_QUERIES.desktop(_templateObject1()), themedColor("night"));
var DropDownRow = styled(Box)(_templateObject3(), font("main", {
    fontSize: "1.4rem",
    fontWeight: 400
}));
var DropDownMenu = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ jsx(StyledDropDown, _object_spread_props(_object_spread({
        as: "ul",
        flexDirection: "column",
        pb: "12px",
        pt: "9px",
        ref: ref
    }, props), {
        children: children
    }));
});

export { DropDownMenu, DropDownRow };
